import SizeSelector from './components/SizeSelector/SizeSelector.vue';
import IndexSelector from './components/IndexSelector/IndexSelector.vue';
import Grid from './components/Grid/Grid.vue';
import Header from './components/Header/Header.vue';
import Rules from './components/Rules/Rules.vue';
import Hints from './components/Hints/Hints.vue';
import Definitions from './components/Definition/Definition.vue';
import LostMessage from './components/LoseMessage/LoseMessage.vue';
import LivesDisplay from './components/LivesDisplay/LivesDisplay.vue';
import WinMessage from './components/WinMessage/WinMessage.vue';
import PuzzleSelector from './components/PuzzleSelector/PuzzleSelector.vue'
import Login from './components/Login.vue'
import LoginButton from './components/LoginButton.vue'
import RankingPopup from './components/RankingPopup/RankingPopup.vue'
import InfiniteMode from './components/InfiniteMode/InfiniteMode.vue'
import { authService, isAuthenticated, user } from './services/auth'
import { config } from './config'

export default {
  name: "App",

  components: {
    SizeSelector,
    IndexSelector,
    Grid,
    Header,
    Rules,
    Hints,
    Definitions,
    LostMessage,
    LivesDisplay,
    WinMessage,
    PuzzleSelector,
    Login,
    LoginButton,
    RankingPopup,
    InfiniteMode
  },

  data() {
    return {
      // these will be chosen by the child components:
      selectedSize: 5,
      selectedIndex: 1,
      isAuthenticated: false,

      secretGrid: [],
      guessGrid: [],
      lostGrid: [],

      generatedHtml: '',
      dataLoaded: false,
      lambda_api: true,
      is_showLetterType: false,
      lives: this.selectedSize,
      has_lost: false,
      defs2: {},
      hasdef2: [],
      hint1_is_disabled: false,
      hint2_is_disabled: false,
      hint3_is_disabled: false,
      def2_empty: false,

      totalLives: this.selectedSize,
      toggleVerSolucion: false,
      messageLostButton: "Ver solución",
      puzzle_nb: undefined,
      rulesAreVisible: false,
      finished_playing: false,

      // New fields for tracking
      hints_used: 0,
      startTime: Date.now(),
      timeSpent: 0,

      // Infinite mode
      infiniteMode: false,

      defs_mapping: {
        "[adjetivo]": "adj.",
        "[adjetivo masculino]": "adj. m.",
        "[adjetivo femenino]": "adj. f.",
        "[adverbio]": "adv.",
        "[verbo transitivo]": "verbo tr.",
        "[verbo intransitivo]": "verbo intra.",
        "[nombre femenino]": "nombre f.",
        "[nombre masculino]": "nombre m.",
        "[nombre masculino y femenino]": "nombre m. y f.",
        "[interjección]": "interj.",
      },

    };
  },

  computed: {
    isSolved() {
      // Check if every cell in guessGrid matches secretGrid
      return this.guessGrid.every((row, rowIndex) =>
        row.every(
          (cell, colIndex) =>
            cell.value === this.secretGrid[rowIndex][colIndex] &&
            cell.color === "Lawngreen"
        )
      );
    },

    getUsername() {
      if (this.isAuthenticated && user.value) {
        return "Hola " + user.value.username + "! "
      }
      else {
        return ""
      }
    },

    showInfiniteMode() {
      // Only show infinite mode button for daily puzzles and when not already enabled
      return this.puzzle_nb !== undefined && !this.infiniteMode;
    },

    displayHtml() {
      if (!this.finished_playing || !this.secretGrid.length) {
        return this.generatedHtml;
      }

      // Extract words from secretGrid
      const words = this.secretGrid.map(row => row.join('').toLowerCase());

      // Transform generatedHtml to include hyperlinks
      let modifiedHtml = this.generatedHtml;

      // Replace each definition with a clickable hyperlink
      words.forEach((word, index) => {
        const definitionNumber = index + 1;
        const regex = new RegExp(`(<p>${definitionNumber}\\))`, 'g');
        const raeUrl = `https://dle.rae.es/${word}`;
        const linkedDefinition = `<p><a href="${raeUrl}" target="_blank" rel="noopener noreferrer">link RAE</a> ${definitionNumber})`;

        modifiedHtml = modifiedHtml.replace(regex, linkedDefinition);
      });

      return modifiedHtml;
    }
  },

  created() {
    console.log(`Using ${config.usingLocalBackend ? 'local' : 'AWS'} backend`);
    // Subscribe to authentication state changes
    this.isAuthenticated = isAuthenticated.value;
    this.$watch(() => isAuthenticated.value, (newValue) => {
      this.isAuthenticated = newValue;
      // Only load puzzle if authentication state changes
      if (this.isAuthenticated !== newValue) {
        this.loadPuzzle();
      }
    });
    // Initial load - wait for getCurrentUser to complete
    this.initializeApp();
  },

  methods: {
    async initializeApp() {
      // Wait for getCurrentUser to complete
      await authService.getCurrentUser();
      // Now load the puzzle
      await this.loadPuzzle();
    },

    enableInfiniteMode() {
      this.infiniteMode = true;
      // Reset lives to unlimited (represented by a high number)
      // this.lives = 999;
      // Reset hints to be unlimited
      this.hint1_is_disabled = false;
      this.hint2_is_disabled = false;
      this.hint3_is_disabled = false;
      // Save the infinite mode state
      this.saveState();
    },

    async loadPuzzle() {

      const url = `${config.getBackendUrl()}/daily-offset`;
      const response = await fetch(url);
      const data = await response.json();
      const today_puzzle_nb = data['day_offset']

      if (this.isAuthenticated) {

        const alreadyDone = await this.checkPuzzleCompletion(today_puzzle_nb);
        if (alreadyDone) {
          console.log("Loading result from DynamoDB");
          return;
        }
      }

      if (localStorage.getItem('puzzleState')) {

        // if localStorage is from today's puzzle, load it
        if (today_puzzle_nb === JSON.parse(localStorage.getItem('puzzleState'))['puzzle_nb']) {

          const isSameUser = this.loadSavedState();
          if (isSameUser) {
            console.log("Loading localStorage");
            return;
          }
        }



      }

      console.log("Loading new puzzle");
      this.fetchSolution();

    },

    toggleRules(section = "") {
      this.rulesAreVisible = !this.rulesAreVisible;

      if (section != "") {
        setTimeout(() => {
          const ejemploSection = document.getElementById(section);
          if (ejemploSection) {
            ejemploSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 0);
      }


    },


    showLetter(r, c) {
      r--;
      c--;
      this.hints_used++;
      this.guessGrid[r][c].value = this.secretGrid[r][c];
      this.onCellInput(r, c);
      if (!this.infiniteMode) {
        this.hint3_is_disabled = true;
      }
    },

    showDefBis(index) {
      const regex = new RegExp(`(<p>${parseInt(index) + 1}\\))`); // Find the paragraph number
      const newDef = this.defs2[index]

      if (parseInt(index) == this.guessGrid.length) {
        this.generatedHtml = this.generatedHtml + `<p>${index} bis) ` + newDef;
      } else {
        this.generatedHtml = this.generatedHtml.replace(regex, `<p>${index} bis) ` + newDef + "\n" + `<p>${parseInt(index) + 1})`);
      }

      if (!this.infiniteMode) {
        this.hint2_is_disabled = true;
      }
      this.hints_used++;
    },

    showLetterType(index) {
      index--;
      this.is_showLetterType = true;
      this.hints_used++;

      // Define which letters are considered vowels
      const vowels = ['A', 'E', 'I', 'O', 'U', 'Á', 'Á', 'É', 'Í', 'Ó', 'Ú', 'Ü'];

      // Don't clear existing letterType - keep previous patterns

      // 1) Mark the row at `index`
      for (let c = 0; c < this.secretGrid[index].length; c++) {
        const letter = this.secretGrid[index][c].toUpperCase();
        const color = this.guessGrid[index][c].color;
        // If there's a letter and it's not green, mark it V or C
        if (color !== "Lawngreen") {
          this.guessGrid[index][c].letterType = vowels.includes(letter) ? 'V' : 'C';
        }
      }

      // 2) Mark the column at `index`
      for (let r = 0; r < this.secretGrid.length; r++) {
        const letter = this.secretGrid[r][index].toUpperCase();
        const color = this.guessGrid[r][index].color;
        // If there's a letter and it's not green, mark it V or C
        if (color !== "Lawngreen") {
          this.guessGrid[r][index].letterType = vowels.includes(letter) ? 'V' : 'C';
        }
      }

      if (!this.infiniteMode) {
        this.hint1_is_disabled = true;
      }
    },

    handleSizeChange(newSize) {
      this.selectedSize = newSize;
    },

    handleIndexChange(newIndex) {
      this.selectedIndex = newIndex;
    },

    formatDefinition(str) {

      // 1) REMOVE ABREVIATIONS WITH "usado"
      // Match [ ... usado ... ] except when it is [desusado]
      const patternUsado = /\[(?!desusado)[^\]]*usado[^\]]*\]/gi;
      let str_cleaned = str.replace(patternUsado, '').trim();

      // 2) GET START AND END INDEX OF REAL DEFINITION

      // Regex for matching [ ... ] (no nested brackets)
      const re = /\[[^\[\]]+\]/g;
      // Collect all matches along with their positions
      const matches = [...str_cleaned.matchAll(re)];

      // If there are no bracketed parts, just return the original text
      if (matches.length === 0) {
        return str_cleaned;
      }

      // Determine the start index (skipping bracketed parts at the beginning)
      let start_idx = 0;
      for (let i = 0; i < matches.length; i++) {
        const match = matches[i];
        const matchStart = match.index;
        const matchEnd = matchStart + match[0].length;

        if (matchStart === start_idx || str_cleaned.slice(start_idx, matchStart).trim() === '') {
          start_idx = matchEnd;
        } else {
          break;
        }
      }

      // Determine the end index (skipping bracketed parts at the end)
      let end_idx = str_cleaned.length;
      for (let i = matches.length - 1; i >= 0; i--) {
        const match = matches[i];
        const matchStart = match.index;
        const matchEnd = matchStart + match[0].length;

        if (matchEnd === end_idx || str_cleaned.slice(matchEnd, end_idx).trim() === '') {
          end_idx = matchStart;
        } else {
          break;
        }
      }

      // Break the text into three parts: before, middle, after
      const before = str_cleaned.slice(0, start_idx);
      const middle = str_cleaned.slice(start_idx, end_idx);
      const after = str_cleaned.slice(end_idx);

      // 3) REMOVE SQUARE BRACKETS FROM MIDDLE PART

      // Remove square brackets only in the middle part
      const middleCleaned = middle.replace(/\[([^\[\]]+)\]/g, '$1');

      // Reassemble the final string
      const newDef = before + middleCleaned + after;

      // 4) REFORMAT DEFINITION
      const pattern = /\[[^\]]*\]/g;

      let conj = ""

      // Find all bracketed substrings
      const bracketedItems = newDef.match(pattern) || [];

      // Remove bracketed substrings from the original text
      let cleanedText = newDef.replace(pattern, '').trim();

      // Transform bracketed items based on `mapping`
      const bracketedItemsTransformed = [];
      for (const item of bracketedItems) {
        if (this.defs_mapping[item]) {
          bracketedItemsTransformed.push(this.defs_mapping[item]);
        } else if (item.includes("Conj:") || item.includes("Conjugación:")) {
          conj = " " + item;
        }
        else {
          // Remove the square brackets if not in the mapping
          bracketedItemsTransformed.push(item.replace("[", "").replace("]", ""));
        }
      }

      // Create the final cleaned text
      cleanedText = "<span style='opacity: .5; font-style: italic;'>" + bracketedItemsTransformed.join(", ") + "</span>" + " " + cleanedText + conj;

      return cleanedText;

    },

    async fetchSolution() {
      // Clear saved state when starting new puzzle
      localStorage.removeItem('puzzleState');

      try {
        // reset vars
        this.is_showLetterType = false;
        this.dataLoaded = false;
        this.has_lost = false;
        this.totalLives = this.selectedSize;
        this.def2_empty = false;
        this.messageLostButton = "Ver solución";
        this.toggleVerSolucion = false;
        this.finished_playing = false;
        // Reset infinite mode for new puzzles
        this.infiniteMode = false;

        let url;
        const endpoint = this.getEndpoint(this.selectedSize, this.selectedIndex)
        // Rebuild the fetch URL with the chosen parameters
        url = `${config.getBackendUrl()}/${endpoint}`;

        const response = await fetch(url);

        const data = await response.json();

        const solution = JSON.parse(data[0]);
        const defs = JSON.parse(data[1]);

        if (data[2] !== undefined && data[3] !== undefined) {
          this.selectedSize = data[2]
          this.puzzle_nb = data[3]
        }
        const defs2 = {};


        let htmlContent = '';
        for (let i = 0; i < this.selectedSize; i++) {
          let definition = defs[solution[0][i]]["Definicion"];
          let def2 = defs[solution[0][i]]["Definicion_2"];

          definition = this.formatDefinition(definition);
          def2 = this.formatDefinition(def2);

          defs2[i + 1] = def2;

          // Remove "1. " at start, if present
          // The ^ in the regex ensures it only matches at the beginning of the string
          // definition = definition.replace(/^1\. /, "");

          htmlContent += `<p>${i + 1}) ${definition}</p>`;
        }


        this.generatedHtml = htmlContent;
        this.defs2 = defs2

        this.hasdef2 = Object.keys(defs2).filter(key => defs2[key] !== "");

        if (this.hasdef2.length == 0) {
          this.def2_empty = true;
        }
        else {
          this.def2_empty = false;
        }

        // reset everything before using new puzzle
        this.secretGrid = [];
        this.guessGrid = [];
        this.lives = this.selectedSize;

        // parse the incoming data into secretGrid
        const words = String(solution[0]);
        this.secretGrid = words.split(",").map(word => this.removeAccents(word.toUpperCase()).split(""));


        this.hint1_is_disabled = false;
        this.hint2_is_disabled = false;
        this.hint3_is_disabled = false;


        // now build an empty guessGrid
        this.initGuessGrid();

        // Reset tracking variables when loading new puzzle
        this.hints_used = 0;
        this.startTime = Date.now();
        this.timeSpent = 0;

      } catch (error) {
        console.error("Error fetching solution:", error);
      }
    },

    initGuessGrid() {
      // Create guessGrid of the same dimensions as secretGrid
      this.secretGrid.forEach(row => {
        const emptyRow = [];
        for (let i = 0; i < row.length; i++) {
          emptyRow.push({ value: "", color: "#ffffff" });
        }
        this.guessGrid.push(emptyRow);
      });
      this.dataLoaded = true;
    },

    removeAccents(letter) {
      return letter.normalize('NFD')
        .replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi, "$1")
        .normalize();
    },

    // Whenever the user inputs a letter in (rowIndex, colIndex):
    onCellInput(rowIndex, colIndex) {

      // Make sure the letter is uppercase
      const letter = this.removeAccents(this.guessGrid[rowIndex][colIndex].value.toUpperCase());
      this.guessGrid[rowIndex][colIndex].value = letter;

      // (Optional) symmetrical assignment
      // e.g. if symmetrical means [rowIndex,colIndex] -> [colIndex,rowIndex]
      const symRowIndex = colIndex;
      const symColIndex = rowIndex;
      if (symRowIndex !== rowIndex || symColIndex !== colIndex) {
        this.guessGrid[symRowIndex][symColIndex].value = letter;
      }

      // Recompute colors for the entire grid
      this.updateGridColors();

      if (letter) {
        const guessCell = this.guessGrid[rowIndex][colIndex];

        // Only deduct lives if not in infinite mode
        // if (!this.infiniteMode) {
        if (guessCell.color === 'gold') {
          this.lives -= 0.5;
        }
        else if (guessCell.color === 'tomato') {
          this.lives--;
          // }
        }

        // Use the Grid component's focusNextAvailableCell method
        if (this.$refs.grid) {
          this.$refs.grid.focusNextAvailableCell(rowIndex, colIndex);
        }

        // Check for game over or win (only if not in infinite mode)
        if (!this.infiniteMode && this.lives < 0.5) {
          this.lives = 0;
          this.has_lost = true;
          this.lostGrid = this.guessGrid;
          this.storeGameResult();
        } else if (this.isSolved) {
          this.storeGameResult();
        }
      }

      // Save state after each change
      this.saveState();
    },

    async storeGameResult() {
      this.finished_playing = true;

      // If puzzle_nb is undefined, it's not a daily puzzle
      if (this.puzzle_nb === undefined) {
        return;
      }

      // Skip storing results for infinite mode players
      if (this.infiniteMode) {
        console.log("Infinite mode enabled");
        // return;
      }

      try {
        // Calculate time spent
        this.timeSpent = Math.floor((Date.now() - this.startTime) / 1000); // Convert to seconds

        // Convert the grid to a simple 2D array of strings
        const finalGrid = this.has_lost ?
          this.lostGrid.map(row => row.map(cell => cell.value)) :
          null;

        // Calculate lives
        let score;
        if (this.lives === 0) {
          // Count cells with color 'tomato' in lostGrid
          const notCorrectCells = this.lostGrid.reduce((count, row, index1) => {
            return count + row.filter((cell, index2) => cell.color !== 'Lawngreen' && index1 <= index2).length;
          }, 0);

          score = - notCorrectCells;
        }
        else {
          score = this.lives
        }

        const state = {
          selectedSize: this.selectedSize,
          selectedIndex: this.selectedIndex,
          puzzle_nb: this.puzzle_nb,
          guessGrid: this.guessGrid,
          lostGrid: this.lostGrid,
          lives: this.lives,
          hints_used: this.hints_used,
          timeSpent: this.timeSpent,
          has_lost: this.has_lost,
          finished_playing: this.finished_playing,
          startTime: this.startTime,
          hint1_is_disabled: this.hint1_is_disabled,
          hint2_is_disabled: this.hint2_is_disabled,
          hint3_is_disabled: this.hint3_is_disabled,
          secretGrid: this.secretGrid,
          generatedHtml: this.generatedHtml,
          defs2: this.defs2,
          hasdef2: this.hasdef2,
          def2_empty: this.def2_empty,
          dataLoaded: this.dataLoaded,
          infiniteMode: this.infiniteMode,
          username: user.value?.username || 'anonymous'
        };

        const response = await authService.completeGame(
          score,
          finalGrid,
          this.selectedSize,
          this.puzzle_nb,
          this.hints_used,
          this.timeSpent,
          JSON.stringify(state),
          this.infiniteMode
        );

        if (response.is_anonymous) {
          localStorage.setItem('anonymous_id', response.user_id);
        }

        // Show ranking after storing the result
        this.$refs.rankingPopup.show();
      } catch (error) {
        console.error('Failed to store game result:', error);
      }

      // Save final state
      this.saveState();
    },

    setLoserGrid() {
      if (this.toggleVerSolucion == false) {
        // show solution
        this.guessGrid = this.secretGrid.map(row =>
          row.map(letter => ({ value: letter, color: "gray" }))
        );
        this.toggleVerSolucion = true;
        this.messageLostButton = "Ver intento"
      }

      else if (this.toggleVerSolucion == true) {
        // show final status
        this.guessGrid = this.lostGrid;
        this.toggleVerSolucion = false;
        this.messageLostButton = "Ver solución";

      }

    },


    updateGridColors() {
      // 1) First pass: Identify which cells are correct (green) and update them.
      //    Keep track of how many times each letter is needed vs. how many are solved in each row/column.

      // We'll build frequency tables for secretGrid letters:
      // rowLetterCount[rowIndex][letter] = how many times `letter` appears in row rowIndex of the secret.
      // colLetterCount[colIndex][letter] = how many times `letter` appears in column colIndex of the secret.
      const rowLetterCount = Array.from({ length: this.secretGrid.length }, () => ({}));
      const colLetterCount = Array.from({ length: this.secretGrid[0].length }, () => ({}));

      // Populate rowLetterCount & colLetterCount from secretGrid
      this.secretGrid.forEach((row, r) => {
        row.forEach((secretLetter, c) => {
          if (!rowLetterCount[r][secretLetter]) rowLetterCount[r][secretLetter] = 0;
          if (!colLetterCount[c][secretLetter]) colLetterCount[c][secretLetter] = 0;
          rowLetterCount[r][secretLetter]++;
          colLetterCount[c][secretLetter]++;
        });
      });

      // Now track how many times we have "discovered" each letter in each row/column.
      // discoveredRowCount[r][letter] = number of times `letter` is green in row r
      // discoveredColCount[c][letter] = number of times `letter` is green in col c
      const discoveredRowCount = Array.from({ length: this.secretGrid.length }, () => ({}));
      const discoveredColCount = Array.from({ length: this.secretGrid[0].length }, () => ({}));

      // First pass: set green cells and compute discovered counts
      for (let r = 0; r < this.guessGrid.length; r++) {
        for (let c = 0; c < this.guessGrid[r].length; c++) {
          const guessCell = this.guessGrid[r][c];
          const guessValue = this.removeAccents(guessCell.value);
          const secretValue = this.secretGrid[r][c];

          // Initialize color to white or keep it, we'll finalize color below
          guessCell.color = "#ffffff";

          if (guessValue && guessValue === secretValue) {
            // It's a correct (green) guess
            guessCell.color = "Lawngreen";
            guessCell.value = secretValue;

            // Count it as "discovered"
            discoveredRowCount[r][guessValue] =
              (discoveredRowCount[r][guessValue] || 0) + 1;
            discoveredColCount[c][guessValue] =
              (discoveredColCount[c][guessValue] || 0) + 1;
          }
        }
      }

      // 2) Second pass: For each non‐green cell, decide orange or red.
      //    "Orange" if guess letter exists in that row or column AND
      //    there is still an undiscovered instance of that letter in that row or column.
      //    Otherwise, "Red".

      for (let r = 0; r < this.guessGrid.length; r++) {
        for (let c = 0; c < this.guessGrid[r].length; c++) {
          const guessCell = this.guessGrid[r][c];
          const guessValue = guessCell.value;

          // Skip if empty or green
          if (!guessValue) {
            guessCell.color = "#ffffff";
            continue;
          }
          if (guessCell.color === "Lawngreen") {
            // Already green, skip
            continue;
          }

          // Check if letter is in the solution row or column
          const letterInRow = !!rowLetterCount[r][guessValue];
          const letterInCol = !!colLetterCount[c][guessValue];

          if (!letterInRow && !letterInCol) {
            // The letter does not appear at all in row or column
            guessCell.color = "tomato";
            continue;
          }

          // Now we must see if that letter is "still undiscovered" in that row or column.
          // i.e. rowLetterCount[r][guessValue] > discoveredRowCount[r][guessValue] (if letterInRow)
          // or   colLetterCount[c][guessValue] > discoveredColCount[c][guessValue] (if letterInCol)
          const rowNeedsLetter =
            letterInRow &&
            rowLetterCount[r][guessValue] >
            (discoveredRowCount[r][guessValue] || 0);
          const colNeedsLetter =
            letterInCol &&
            colLetterCount[c][guessValue] >
            (discoveredColCount[c][guessValue] || 0);

          if (rowNeedsLetter || colNeedsLetter) {
            guessCell.color = "gold";
          } else {
            guessCell.color = "tomato";
          }
        }
      }
    },

    showRanking() {
      this.$refs.rankingPopup.show();
    },

    saveState() {
      const state = {
        selectedSize: this.selectedSize,
        selectedIndex: this.selectedIndex,
        puzzle_nb: this.puzzle_nb,
        guessGrid: this.guessGrid,
        lostGrid: this.lostGrid,
        lives: this.lives,
        hints_used: this.hints_used,
        timeSpent: this.timeSpent,
        has_lost: this.has_lost,
        finished_playing: this.finished_playing,
        startTime: this.startTime,
        hint1_is_disabled: this.hint1_is_disabled,
        hint2_is_disabled: this.hint2_is_disabled,
        hint3_is_disabled: this.hint3_is_disabled,
        secretGrid: this.secretGrid,
        generatedHtml: this.generatedHtml,
        defs2: this.defs2,
        hasdef2: this.hasdef2,
        def2_empty: this.def2_empty,
        dataLoaded: this.dataLoaded,
        infiniteMode: this.infiniteMode,
        username: user.value?.username || 'anonymous'
      };
      localStorage.setItem('puzzleState', JSON.stringify(state));
    },

    loadSavedState() {
      const savedState = localStorage.getItem('puzzleState');
      if (savedState) {
        const state = JSON.parse(savedState);
        const currentUsername = user.value?.username || 'anonymous';

        // Only load if it's the same user
        if (state.username === currentUsername) {
          Object.assign(this, state);
          return true;
        }
      }
      return false;
    },

    async checkPuzzleCompletion(today_puzzle_nb) {
      try {
        let alreadyDone;

        if (this.isAuthenticated && user.value) {
          // Check if user has completed this puzzle
          const rankingResponse = await fetch(`${config.getBackendUrl()}/game/result/${user.value.username}/${today_puzzle_nb}`);

          if (rankingResponse.status !== 200) {
            console.log("Error retrieving game result");
            alreadyDone = false;
            return alreadyDone;
          }

          const rankingData = await rankingResponse.json();

          if (Object.keys(rankingData).length === 0) {
            console.log("Game result not found");
            alreadyDone = false;
            return alreadyDone;
          }

          const state = JSON.parse(rankingData.state);

          Object.assign(this, state);
          alreadyDone = true
          return alreadyDone
        }
        else {
          console.log("Error with user...");
          alreadyDone = false
          return alreadyDone
        }

      } catch (error) {
        console.error('Error checking puzzle completion:', error);
        // If there's an error, just fetch the puzzle
        alreadyDone = false
        return alreadyDone
      }
    },

    handleAuthChange(isAuthenticated) {
      this.isAuthenticated = isAuthenticated;
      // Remove duplicate loadPuzzle call since it's handled by the watcher
    },
  },
};
